import * as actionTypes from '../actions/actionTypes';

const initialState = {
    editUser: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.EDIT_USER_TOGGLE:
            return {
                ...state,
                editUser: !state.editUser
            };
        case actionTypes.EDIT_USER_SUBMIT:
            return {
                ...state,
                editUser: false
            }
        default:
            return state;
    }
};

export default reducer;